import React, { useEffect } from 'react';
import Navbar from "./../components/Features/Navbar";
import Footer from './../components/Home/Footer';
import { Container, Typography, Card, CardContent, CardActionArea, useMediaQuery } from '@mui/material';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Fade } from 'react-awesome-reveal';
import hr from "./../images/icons/hr.png";
import banniere from './../images/campagne.png';

const Campagne = () => {
  useEffect(() => {
    document.title = 'Soutenir Tsahal Connection | Tsahal Connection';
  }, []);

  const isMobile = useMediaQuery('(max-width:576px)');
  const isTablet = useMediaQuery('(max-width:768px)');

  const imageStyles = {
    width: '100%',
    height: isMobile ? '200px' : isTablet ? '280px' : 'auto',
    maxHeight: isMobile ? '200px' : isTablet ? '320px' : '480px',
    objectFit: 'cover',
    objectPosition: 'center top',
  };

  return (
    <div>
      <Navbar />
      <Fade triggerOnce>
        <div className="landing-page" style={{ paddingTop: '2rem' }}>
          <img src={banniere} alt="landing-page-pic" style={imageStyles} />
        </div>

        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', marginTop: '2rem' }}>
          <h1 style={subHeader}>Campagne</h1>
          <h1 style={mainHeader}>🌟 Soutenez les soldats francophones de Tsahal !</h1>
          <img src={hr} alt="HR" width="80" height="50" />

          <div style={{
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'center',
              flexWrap: 'wrap',
              gap: '2rem',
              marginTop: '2rem',
              marginBottom: '1rem'
            }}>
              <Card style={donCardStyle} onClick={() => window.open("https://dl.tsahalco.com/donisrael", "_blank")}>
                <CardActionArea>
                  <CardContent>
                    <Typography variant="h6" style={cardTitleStyle}>🇮🇱 Depuis Israël :</Typography>
                    <Typography variant="body2" style={cardBodyStyle}>https://dl.tsahalco.com/donisrael</Typography>
                    <Typography variant="body2" style={cardBodyStyle}>✉️ Reçu fiscal – Seif 46</Typography>
                  </CardContent>
                </CardActionArea>
              </Card>

              <Card style={donCardStyle} onClick={() => window.open("https://dl.tsahalco.com/donfrance", "_blank")}>
                <CardActionArea>
                  <CardContent>
                    <Typography variant="h6" style={cardTitleStyle}>🇫🇷 Depuis la France :</Typography>
                    <Typography variant="body2" style={cardBodyStyle}>https://dl.tsahalco.com/donfrance</Typography>
                    <Typography variant="body2" style={cardBodyStyle}>✉️ Reçu fiscal – CERFA</Typography>
                  </CardContent>
                </CardActionArea>
              </Card>
            </div>

          <Container maxWidth="md" style={{ marginTop: '3rem', marginBottom: '3rem' }}>
            <Typography variant="body1" style={paragraphStyle}>
            Chaque année, des centaines de jeunes francophones intègrent l’armée israélienne, souvent loin de leur famille et de leurs repères.
            Chez Ach Gadol, nous les accompagnons dès leur arrivée jusqu’à leur intégration complète dans l’armée.
            Exceptionnellement cette année, en raison d’un nombre bien plus élevé de jeunes intégrant Tsahal, notre budget initial a été complètement dépassé.
            Il nous manque encore une somme conséquente pour pouvoir faire tout notre possible afin de les intégrer au mieux dans l’armée Israélienne. 
            Nous lançons donc une campagne pour récolter 70 000 shekels, afin de financer :
            <ul>
              <li>L’accompagnement de 100 nouveaux soldats, pour leur permettre d’être guidés par d’anciens soldats seuls francophones devenus mentors.
              </li>
              <li>Les cadeaux de bienvenue, essentiels pour les jeunes qui s’apprêtent à servir. 
              </li>
              <li>8 journées de préparation à l’armée, spécialement conçues pour aider les futurs soldats à mieux comprendre le système militaire, à se préparer mentalement et physiquement, et à faciliter leur intégration dans Tsahal.
              </li>
            </ul>
            Aidez-nous à continuer cette mission essentielle. Chaque don compte !
            </Typography>
           

            <Typography variant="h4" style={sectionTitle}>🤝 Comment faire un don ?</Typography>

            <div style={{
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'center',
              flexWrap: 'wrap',
              gap: '2rem',
              marginTop: '2rem',
              marginBottom: '4rem'
            }}>
              <Card style={donCardStyle} onClick={() => window.open("https://dl.tsahalco.com/donisrael", "_blank")}>
                <CardActionArea>
                  <CardContent>
                    <Typography variant="h6" style={cardTitleStyle}>🇮🇱 Depuis Israël :</Typography>
                    <Typography variant="body2" style={cardBodyStyle}>https://dl.tsahalco.com/donisrael</Typography>
                    <Typography variant="body2" style={cardBodyStyle}>✉️ Reçu fiscal – Seif 46</Typography>
                  </CardContent>
                </CardActionArea>
              </Card>

              <Card style={donCardStyle} onClick={() => window.open("https://dl.tsahalco.com/donfrance", "_blank")}>
                <CardActionArea>
                  <CardContent>
                    <Typography variant="h6" style={cardTitleStyle}>🇫🇷 Depuis la France :</Typography>
                    <Typography variant="body2" style={cardBodyStyle}>https://dl.tsahalco.com/donfrance</Typography>
                    <Typography variant="body2" style={cardBodyStyle}>✉️ Reçu fiscal – CERFA</Typography>
                  </CardContent>
                </CardActionArea>
              </Card>
            </div>

            <Typography variant="body1" style={paragraphStyle}>
              💙 <strong>Merci de soutenir nos soldats francophones</strong><br />
              Chaque don compte. Ensemble, faisons la différence.
            </Typography>

            <Typography variant="body1" style={{ ...paragraphStyle, marginTop: '2rem' }}>
              L’équipe de Tsahal Connection<br />
              <a href="https://www.tsahalco.com" target="_blank" rel="noreferrer" style={{ color: '#1398aa' }}>
                www.tsahalco.com
              </a>
            </Typography>
          </Container>
        </div>
        <Footer />
      </Fade>
    </div>
  );
};

// Styles
const subHeader = {
  fontFamily: 'Montserrat',
  fontWeight: '800',
  fontSize: '1.2rem',
  marginBottom: '2rem',
  color: '#ae39ed',
  textAlign: 'center'
};

const mainHeader = {
  fontFamily: 'Montserrat',
  fontWeight: '700',
  fontSize: '48px',
  textAlign: 'center'
};

const paragraphStyle = {
  fontFamily: 'Montserrat',
  lineHeight: '1.8',
  fontSize: '20px',
  fontWeight: '500',
  color: '#2f3036',
  marginBottom: '1.5rem'
};

const sectionTitle = {
  fontFamily: 'Montserrat',
  fontSize: '34px',
  fontWeight: '700',
  marginTop: '2rem',
  marginBottom: '1rem',
  color: '#2f3036'
};

const donCardStyle = {
  cursor: 'pointer',
  borderRadius: '16px',
  width: '260px',
  border: '1px solid #ddd',
  boxShadow: '0 4px 10px rgba(0,0,0,0.1)',
  transition: 'transform 0.2s',
};

const cardTitleStyle = {
  fontFamily: 'Montserrat',
  fontWeight: '600',
  marginBottom: '0.5rem'
};

const cardBodyStyle = {
  fontFamily: 'Montserrat',
  color: '#2f3036',
  fontWeight: '500'
};

export default Campagne;
